
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fe9500","d":"M994.9 500c0 273.2-222 495.3-495.3 495.3S4.4 773.2 4.4 500 226.4 4.7 499.7 4.7c118.9 0 232.9 42.4 323.1 120.2 6.8 5.5 13 11.6 19.8 17.8 22.5 21.2 42.4 45.1 60.1 69.7 1.4 2 2.7 3.4 4.1 5.5 57.4 82.6 88.1 181 88.1 282.1z"}}),_c('path',{attrs:{"fill":"#fe9500","d":"M984.7 96.3l-81.3 116.1c-17.8-25.3-38.3-48.5-60.1-69.7-6.1-6.1-13-11.6-19.1-17.8l66.9-95c18.4-26 54.6-32.1 80.6-14.3s31.4 54.7 13 80.7z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M902.7 212.4L575.5 678.3l-38.9 54.6c-14.3 20.5-42.4 25.3-62.8 10.9-2-1.4-4.1-2.7-5.5-4.8L243.5 515c-22.5-22.5-22.5-59.4 0-82l2-2c22.5-22.5 59.4-22.5 82 0l149.6 149.6c6.8 6.8 18.4 6.8 25.3 0l2-2 318.3-452.9c6.8 5.5 13 11.6 19.1 17.8 23.4 20.4 43.2 43.6 60.9 68.9z"}})])
          )
        }
      }
    